module.exports = __webpack_public_path__ + "img/en_tis60_5.cf820958.png";